type Validator = (value: string) => boolean;

type ValidationRule<T> = {
  field: keyof T | string;
  validator: Validator;
  errorKey: string;
  optional?: boolean; // If true, skip validation when empty
};

type Errors<T> = Partial<Record<keyof T | string, string>>;

export function validateFields<T>(
  values: Partial<T>,
  rules: ValidationRule<T>[],
  t: (key: string) => string
): Errors<T> {
  const errors: Errors<T> = {};

  for (const { field, validator, errorKey, optional } of rules) {
    let value = '';

    if (field in values) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const rawValue = (values as any)[field];
      value = typeof rawValue === 'string' ? rawValue.trim() : '';
    } else if (typeof field === 'string') {
      // If field not in values, try to get it as string key (if values is an object with extra keys)
      value = '';
    }

    if (optional && value === '') {
      continue;
    }

    if (!validator(value)) {
      errors[field] = t(errorKey);
    }
  }

  return errors;
}
